module.exports = __webpack_public_path__ + "img/iso9001-cn.c34e6653.png";